import { toast } from 'react-hot-toast';

const UserInfoCard = ({ roomId, userData }) => {
  return (
    <div className="bg-white/5 backdrop-blur-xl rounded-xl p-8 border border-white/10 shadow-2xl shadow-purple-500/10">
      <div className="flex items-center gap-3 mb-8">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="text-purple-400"
              >
                <circle cx="12" cy="12" r="1" />
                <path d="M12 1v6m0 6v4" />
                <path d="M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24" />
                <path d="M1 12h6m6 0h4" />
                <path d="M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24" />
                <path d="M12 23v-6m0-6v-4" />
                <path d="M19.78 19.78l-4.24-4.24m-5.08-5.08l-4.24-4.24" />
                <path d="M23 12h-6m-6 0h-4" />
                <path d="M19.78 4.22l-4.24 4.24m-5.08 5.08l-4.24 4.24" />
              </svg>
            </div>
            <span className="text-white font-semibold">
              Balance: {userData?.balance && userData.balance.toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      <div className="mb-6 relative z-10">
        <label className="text-white/90 text-sm font-medium mb-2 block">
          Room id
        </label>
        <div className="bg-[#1B1E3E]/60 rounded-xl p-3 flex items-center justify-between">
          <span className="text-white/80 text-sm truncate flex-1 mr-2">
            {roomId?.substring(0, 20)}.....
          </span>
          <button
            onClick={() => {
              if (roomId && navigator.clipboard) {
                navigator.clipboard.writeText(roomId);
                toast.success('Room ID copied!');
              }
            }}
            className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <rect
                x="9"
                y="9"
                width="13"
                height="13"
                rx="2"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="mb-6 relative z-10">
        <label className="text-white/90 text-sm font-medium mb-2 block">
          Public Key
        </label>
        <div className="bg-[#1B1E3E]/60 rounded-xl p-3 flex items-center justify-between">
          <span className="text-white/80 text-sm truncate flex-1 mr-2">
            {userData?.publicKey?.substring(0, 20)}.....
          </span>
          <button
            onClick={() => {
              if (userData?.publicKey && navigator.clipboard) {
                navigator.clipboard.writeText(userData?.publicKey);
                toast.success('Public Key copied!');
              }
            }}
            className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <rect
                x="9"
                y="9"
                width="13"
                height="13"
                rx="2"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="mb-8 relative z-10">
        <label className="text-white/90 text-sm font-medium mb-2 block">
          Private Id
        </label>
        <div className="bg-[#1B1E3E]/60 rounded-xl p-3 flex items-center justify-between">
          <span className="text-white/80 text-sm truncate flex-1 mr-2">
            {userData?.privateKey?.substring(0, 20)}.....
          </span>
          <button
            onClick={() => {
              if (userData?.privateKey && navigator.clipboard) {
                navigator.clipboard.writeText(userData?.privateKey);
                toast.success('Private ID copied!');
              }
            }}
            className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <rect
                x="9"
                y="9"
                width="13"
                height="13"
                rx="2"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserInfoCard;
